const ufeApi = require('services/api/ufeApi');
const urlUtils = require('utils/Url');
const { UUIDv4 } = require('utils/UUID');

const UFE = 'UFE';
const CORRELATION_ID = 'correlationId';

function getFulfillmentOptions(payload = {}, details = false) {
    const { sdnDomainBaseUrl, sdnUfeAPIUserKey } = Sephora.configurationSettings;

    const queryParams = new Map();
    queryParams.set('apikey', sdnUfeAPIUserKey);
    queryParams.set('details', details);

    const requestId = UUIDv4();
    const queryString = urlUtils.buildQuery(queryParams);
    const url = sdnDomainBaseUrl + '/v1.0/getFulfillmentOptions' + queryString;
    const options = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            'Content-Type': 'application/json',
            [CORRELATION_ID]: `${UFE}_${requestId}`
        }
    };

    return ufeApi.makeRequest(url, options).then(data => (data.errorCode ? Promise.reject(data) : data));
}

module.exports = getFulfillmentOptions;
